import { Chip, styled } from "@mui/material";

export default styled(Chip)({
  borderRadius: 8,
});
